'use client';

import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import { FC, useEffect, useRef } from 'react';
import { useLottieAnimation } from './LottieMedia.hooks';
import { LottieMediaProps } from './LottieMedia.types';

const LottieMedia: FC<LottieMediaProps> = ({
  animation,
  fallbackSrc,
  alt = '',
  loop = true,
  renderer = 'svg',
  className = '',
}) => {
  const animationRef = useRef<LottieRefCurrentProps | null>(null);
  const { animationData, isReady, shouldAnimate, setIsReady } = useLottieAnimation(animation);

  useEffect(function stopIfReducedMotion() {
    if (!animationRef.current) {
      return;
    }

    if (!shouldAnimate) {
      animationRef.current.stop();
    }
  }, [shouldAnimate]);

  const showLottie = animationData && shouldAnimate;

  return (
    <div className={`relative w-full ${className}`}>
      {!(isReady && showLottie) && (
        <img
          src={fallbackSrc}
          alt={alt}
          className="block w-full h-auto transition-opacity duration-200"
        />
      )}

      {showLottie && (
        <div className={isReady ? 'w-full' : 'absolute inset-0'}>
          <Lottie
            animationData={animationData}
            loop={loop}
            autoplay={true}
            lottieRef={animationRef}
            renderer={renderer}
            style={{
              width: '100%',
              height: '100%',
            }}
            onDOMLoaded={function () {
              setIsReady(true);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default LottieMedia;
